<section class="container sign-container two-factor-auth-container" id="twoFactorAuth">
    <header class="background-header">
        <img class="background-header-img" src="../../../assets/img/{{ themeService.theme }}/header-background.svg"
            alt="" />
        <section class="navbar-brand navbar-brand-choose-plan">
            <img class="main-logo main-img-about-me" src="../../assets/img/{{themeService.theme}}/main-logo.png"
                alt="Company Logo" width="125px">
        </section>
    </header>
    <header class="mobile-header">
        <img src="../../assets/img/{{themeService.theme}}/main-logo.png" alt="Company Logo" width="125px">
    </header>

    <section class="container-fluid dynamic-collapse-top">
        <div class="dynamic-collapse">
            <div class="dynamic-collapse-header">
                <h1 class="col">Two Factor Authentication</h1>
            </div>
            <div class="dynamic-collapse-main">
                <div class="dynamic-collapse-content">
                    <div *ngIf="displayNotification">
                        <app-notification-bubble></app-notification-bubble>
                    </div>
                    <ng-container *ngIf="!mfaStatus && !emailMfaStatus">
                        <div class="keep-plan-secure">To help keep your account secure, we'll text you a code each time
                            you
                            want to log in.</div>
                        <div class="input-container">
                            <input type="tel" class="phone-number" placeholder="Enter mobile number" #inputElement
                                required>
                            <div *ngIf="!inputElement.value" class="error-message">{{ errorMessage }}</div>
                            <input type="submit" class="continue-btn" value="Continue"
                                (click)="callMFA(inputElement.value)">
                        </div>
                        <div class="email-auth">
                            <span class="use-email" (click)="switchToEmailMfa('nosend')">Click here</span> to use email
                            authentication instead.
                        </div>
                    </ng-container>
                    <app-mfa *ngIf="mfaStatus" [text]="getTextWithPhoneNumber()" [textBtn]="'Verify'" [myUser]="myUser"
                        (statusMFA)="statusMFA($event)" [errorMessageMfaNotReceiving]="errorMessageMfaNotReceiving"
                        [phoneNumber]="inputValue" (updatephoneNumber)="updatePhoneNumber($event)"
                        (switchToEmail)="switchToEmail($event)" (sendToLocationEvent)="sendToLocation($event)">
                    </app-mfa>
                    <div class="resend-phone-code" *ngIf="mfaStatus">No code received?
                        <button class="use-email resend-btn" (click)="sendANewCode()" [disabled]="resendCodeDisabled"
                            [ngClass]="{'disabled-btn': resendCodeDisabled}">Click here</button>
                        to receive a new one or <span class="modify-number" (click)="modifyMobileNumber()">here</span>
                        to modify your mobile number.
                    </div>
                    <div class="counter" *ngIf="resendCodeDisabled">
                        You can resend a new one in {{ counter }} seconds.
                    </div>
                    <app-mfa *ngIf="emailMfaStatus"
                        [text]="'For your security, we have sent an authentication code to your email. Please retrieve it and enter it below to continue. You may have to check your junk inbox.'"
                        [textBtn]="'Verify'" [myUser]="myUser" (statusMFA)="statusMFA($event)">
                    </app-mfa>
                </div>
            </div>
        </div>
    </section>
</section>